module.exports = __webpack_public_path__ + "static/img/projectManage.dd97d714.png";